import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-170q130-118 193-211 62-93 62-173 0-115-74-188t-181-73-181 73q-74 73-74 188 0 80 64 173t191 211Zm0 82q-12 0-24-4-13-4-22-13-45-39-96-89-50-50-93-108t-71-122q-28-64-28-130 0-155 101-248t233-93 234 93q101 93 101 248 0 66-29 130-28 64-71 122t-93 108q-51 50-96 89-9 9-22 13t-24 4Zm0-472Zm0 74q31 0 53-21 22-22 22-53t-22-53q-22-22-53-22t-53 22q-21 22-21 53t21 53q22 21 53 21Z"/>',
  f: '<path d="M480-88q-12 0-24-4-13-4-22-13-45-39-96-89-50-50-93-108t-71-122q-28-64-28-130 0-155 101-248t233-93 234 93q101 93 101 248 0 66-29 130-28 64-71 122t-93 108q-51 50-96 89-9 9-22 13t-24 4Zm0-398q31 0 53-21 22-22 22-53t-22-53q-22-22-53-22t-53 22q-21 22-21 53t21 53q22 21 53 21Z"/>',
};

export default data;
